import { useParamsSearch } from '@anytag/shared-hooks';
import { YoutubeCMSInvoicesSearchSchemaType } from '../schemaTypes';

export const useYoutubeCMSInvoicesFilter = () => useParamsSearch<YoutubeCMSInvoicesSearchSchemaType>();
